import React from "react";
import { Accordion } from "../../../components/accordion/accordian";
import TopServiceBanner from "../../../components/ServiceBanner/TopServiceBanner";
import BottomServiceBanner from "../../../components/ServiceBanner/BottomServiceBanner";
import BottomBanner from "../../../components/ServiceBanner/BottomBanner";
import styled from "styled-components";
import banner from "../../../assets/images/immunization/banner.png";

const faqsData = [
  {
    id: 1,
    header: "Does insurance cover vaccinnations?",
    body: "Many insurance plans will cover vaccinations. To ensure coverage, contact your pharmacist or insurance provider.",
  },
  {
    id: 2,
    header: "How safe are vaccines?",
    body: "Vaccines go rigorous testing as required by law and are continuously monitored for safety and efficacy once licensed and in use. Monitoring health problems after receiving vaccinations is essential to ensure vaccines are held to the highest safety standards.",
  },
  {
    id: 3,
    header: "Do vaccines have side effects?",
    body: "It is possible that minor side effects (sore arm or low-grade fever) can be experienced after receiving a vaccination. More information on each vaccine is available on the specific vaccine health pages.",
  },
  {
    id: 4,
    header: "What are the differeces between immunizations and vaccinations?",
    body: "A vaccination refers to the process of receiving a vaccine whereas an immunization refers to the process by which a person becomes protected against a disease through vaccination.",
  },
  {
    id: 5,
    header: "Are vaccinations required for students to go back to school?",
    body: "Many school systems now require 5th and 6th graders to receive a Tdap immunization. Meningitis vaccinations are also required by some colleges before incoming freshman can move into dorms or attend classes. To find out what vaccines are required for your individual situation, please contact your local school district or specific college.",
  },
  {
    id: 6,
    header: "What is the difference between influenza and COVID-19",
    body: "Influenza (Flu) and COVID-19 are both contagious respiratory illnesses, but they are caused by different viruses. COVID-19 is caused by infection with a new coronavirus (called SARS-CoV-2) and flu is caused by infection with influenza viruses. Because some of the symptoms of flu and COVID-19 are similar, it may be hard to tell the difference between them based on symptoms alone, and testing may be needed to help confirm a diagnosis.\n\nCOVID-19 seems to spread more easily than flu and causes more serious illnesses in some people. It can also take longer before people show symptoms and people can be contagious for longer.\n\nWhile more is learned every day, there is still a lot that is unknown about COVID-19 and the virus that causes it. This page compares COVID-19 and flu, given the best available information to date.",
  },
  {
    id: 7,
    header: "Because symptoms are similar how will I tell if I have COVID-19 or flu?",
    body: "Although there are some differences between flu and COVID-19, they also share signs and symptoms. For this reason, it may be hard to tell the difference between them based on symptoms alone. Testing may be needed to help confirm a diagnosis. Get more information on symptoms of COVID-19 and flu.",
  },
  {
    id: 8,
    header: "Can I have flu and COVID-19 at the same time?",
    body: "Yes. It is possible have flu, as well as other respiratory illnesses, and COVID-19 at the same time. Health experts are still studying how common this can be. Some of the symptoms of flu and COVID-19 are similar, making it hard to tell the difference between them based on symptoms alone. Diagnostic testing can help determine if you are sick with flu or COVID-19.",
  },
  {
    id: 9,
    header: "Will the flu shot prevent me from getting COVID-19?",
    body: "Getting a flu vaccine will not protect against COVID-19, however flu vaccination has many other important benefits. Flu vaccines have been shown to reduce the risk of flu illness, hospitalization, and death. Getting a flu vaccine this fall will be more important than ever, not only to reduce your risk from flu but also to help conserve potentially scarce health care resources.",
  },
  {
    id: 10,
    header: "Why is getting an annual flu shot one of the best ways to prevent getting the flu?",
    body: "It's important to get the flu shot every year because the body's immunity response to the vaccine declines over time. Flu viruses can also alter from year to year, so receiving a new vaccine formulation is required to provide optimal protection. It takes up to two weeks for your immunity to build up after getting a flu shot, so the CDC recommends you get vaccinated as soon as flu vaccines become available. Getting a flu shot is the best way to protect yourself and your family from catching the flu.",
  },
  {
    id: 11,
    header: "Why should I get a flu vaccine if ot does not protect me from COVID-19?",
    body: "This season, it is likely that flu viruses and the virus that causes COVID-19 will both be circulating at the same time. So, it is more important than ever to get a flu vaccine in order to reduce risk from the flu and reduce the burden on our health care system during the COVID-19 pandemic.",
  },
  {
    id: 12,
    header: "Can I receive another vaccine with my COVID-19 vaccine?",
    body: "COVID-19 vaccines and other vaccines may now be administered without regard to timing. This includes simultaneous administration of COVID-19 vaccine and other vaccines on the same day, as well as coadministration within 14 days. For more information see coadminstration with other vaccines.",
  },
  {
    id: 13,
    header: "What is the difference between available flu shots?",
    body: "Four–strain (quadrivalent) vaccine: protects against four different strains of flu virus.\n\nSenior–dose vaccine: developed for people over 65 years old.\n\nBoth quadrivalent and senior–dose flu shots are available at Winn-Dixie Pharmacy.",
  },
];

const Immunizations = () => {
  return (
    <Container>
      <TopServiceBanner title="About Us" banner={banner} />

      <AccordionContainer>
        <Accordion>
          <Accordion.Title>Vaccine FAQs</Accordion.Title>
          <Accordion.Frame>
            {faqsData.map((item) => (
              <Accordion.Item key={item.id}>
                <Accordion.Header>{item.header}</Accordion.Header>
                <Accordion.Body>{item.body}</Accordion.Body>
              </Accordion.Item>
            ))}
          </Accordion.Frame>
        </Accordion>
      </AccordionContainer>

      <BottomServiceBanner />
      <BottomBanner />
    </Container>
  );
};

export default Immunizations;

const AccordionContainer = styled.div`
border: 5px solid var(--color-gray);
max-width: 824px;
margin: auto;
`;

const Container = styled.div``;

// const Title = styled.h1`
//   font-size: 40px;
//   line-height: 1.1;
//   color: var(--color-blue);
//   text-align: center;
//   margin-top: 3rem;

//   &:hover {
//     color: var(--color-red);
//   }

//   @media (max-width: 600px) {
//     font-size: 30px;
//   }
// `;
// const SubTitle = styled.h2`
//   font-size: 23px;
//   font-weight: normal;
//   line-height: normal;
//   text-align: center;
//   padding: 0rem 3rem 3rem 3rem;
//   margin-top: 2rem;
//   opacity: 0.6;

//   @media (max-width: 600px) {
//     font-size: 18px;
//     padding-right: 0.5rem;
//     padding-left: 0.5rem;
//   }

//   @media (max-width: 460px) {
//     font-size: 15px;
//   }
// `;
